export default __webpack_public_path__ + "static/media/NOTO_SANS_SC.1e348b3a.ttf";